export const ERROR_NOT_MANAGED = "error_not_managed";
export const GENERIC_ERROR = "generic_error";

export const AUTH_REQ_RECENT_LOGIN = "auth/requires-recent-login";
export const AUTH_USER_NOT_FOUND = "auth/user-not-found";
export const AUTH_WRONG_PASSWORD = "auth/wrong-password";

export const ACCOUNT_EXISTS_DIFFERENT_CREDENTIAL = "auth/account-exists-with-different-credential";
export const AUTH_EMAIL_ALREADY_IN_USE = "auth/email-already-in-use";